import { useQuery } from '@tanstack/react-query';
import { getLocales } from 'api/locales';
import { localesKeys } from 'api/queryKeys';

const LOCALES_STALE_MS = 7 * 24 * 60 * 60 * 1000; // 7 dni

/** Lista locale (np. do Locale ID). languageCodes – opcjonalnie filtruj po językach firmy. */
export const useLocalesQuery = (languageCodes?: string[]) =>
  useQuery({
    queryKey: localesKeys.all(languageCodes),
    queryFn: () => getLocales(languageCodes).then((res) => res.data ?? []),
    staleTime: LOCALES_STALE_MS,
    gcTime: LOCALES_STALE_MS
  });
